import * as types from '../../../../lib/actionTypes.es6'

export function getClaimsDcpRequest(payload){
  return{
    type: types.GET_CLAIMS_DCP_REQUEST,
    payload: payload
  }
}


export const getClaimsDcpSuccess = (payload) =>{
  return{
    type: types.GET_CLAIMS_DCP_SUCCESS,
    payload: payload,
  }
}

export const getClaimsDcpFailure = (error) =>{
  return{
    type: types.GET_CLAIMS_DCP_FAILURE,
    payload: error,
  }
}

export function bulkApproveRequest(payload){
  return{
    type: types.BULK_APPROVE_REQUEST,
    payload: payload
  }

}

export function bulkApproveSuccess(payload){
  return{
    type: types.BULK_APPROVE_SUCCESS,
    payload: payload
  }

}


export function bulkApproveFailure(error){
  return{
    type: types.BULK_APPROVE_FAILURE,
  }
}


export function resetbulkApprovalSuccess() {
  return {
    type: types.RESET_BULK_APPROVE_SUCCESS,
  };
}
export function resetbulkApprovalFailure() {
  return {
    type: types.RESET_BULK_APPROVE_FAILURE,
  };
}

export const assignLawyerRequest = (payload) =>{
  return{
    type: types.ASSIGN_LAWYER_REQUEST,
    payload: payload,
  }
}

export const assignLawyerSuccess = (response) =>{
  return{
    type: types.ASSIGN_LAWYER_SUCCESS,
    payload: response,
  }
}

export const assignLawyerFailure = (error) =>{
  return{
    type: types.ASSIGN_LAWYER_FAILURE,
    payload: error,
  }
}

export function resetAddLawyerSuccessAlert(error) {
  return {
    type: types.RESET_ADD_LAWYER_SUCCESS,
  };
}

export function resetAddLawyerError(error) {
  return {
    type: types.RESET_ADD_LAWYER_ERROR,
  };
}